// extracted by mini-css-extract-plugin
export default {"clientTours":"styles_clientTours__gBmoA","content":"styles_content__nxvvr","main":"styles_main__Lq3gt","title":"styles_title__E1BW7","count":"styles_count__9R4jh"};